// extracted by mini-css-extract-plugin
module.exports = {"activityListTitle":"J4zXh","activitiesCustomScrollbar":"ktWzb"};